import client from "../server/Client";
import {useQuery} from "@tanstack/react-query";

const formNotes = (formId) => client.get(`forms/${formId}/notes`);
export const useFormNotes = (formId) => useQuery(['formNotes', formId],
    () => formNotes(formId),
    {select: data => data?.data?.result})